import React, { useEffect, useState } from "react";
import classes from "./AvailableMeals.module.css";
import Card from "../UI/Card";
import MealItem from "./MealItem/MealItem";

const AvailableMeals = () => {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [httpError, setHttpError] = useState(null);


  useEffect(() => {
    const fetchMeals = async () => {
      const response = await fetch(
        "https://task-react-project-default-rtdb.firebaseio.com/meals.json"
      );

      if(!response.ok){
        throw new Error('seomthing went wrong');
      }

      const responseData = await response.json();
        // console.log(responseData);
      const loadedMeals = [];
      
      for (const key in responseData) {
        loadedMeals.push({
          id: key,
          name: responseData[key].name,
          description: responseData[key].description,
          price: responseData[key].price,
        });
      }
      
      setMeals(loadedMeals);
      setLoading(false);

    };

      fetchMeals().then().catch(error => {
        setLoading(false);
        setHttpError(error.message);
      });
  }, []);


  if(loading){
    return (
      <section className={classes.MealsLoading}>
        <p>loading ...</p>
      </section>
    ); 
  }
  if(httpError){
    return (
      <section className={classes.MealsError}>
        <p>{httpError}</p>
      </section>
    )
  }
  // console.log(meals);
  const mealsList = meals.map((meal) => (
    <MealItem
      key={meal.id}
      id={meal.id}
      name={meal.name}
      description={meal.description}
      price={meal.price}
    />
  ));


  return (
    <section className={classes.meals}>
      <Card>
        <ul>{mealsList}</ul>
      </Card>
    </section>
  );
};

export default AvailableMeals;
